<template>
  <span class="tab">
    <span :class="['right-tab',{'Icon':item.acquiesceType,'curr':initNum==index}]"
          v-show="item.name && item.flowType == 'flow'">
      <span @click.stop="tabSwitch($event,item)">{{item.name}}</span>
    </span>
    <leftRightMenu :item="sub"
             v-for="(sub,ind) in tabNav"
             :key="ind"></leftRightMenu>
  </span>
</template>

<script>
export default {
  name: "leftRightMenu",
  props: {
    item: Object,
    index: Number,
  },
  data () {
    return {
      tabNav: [],
      twids: 0,
      initNum: 0
    }
  },
  computed:{

  },
  //跨级触发方法
  inject: ["fatherMethod", "updateWidth", "tabRight"],
  methods: {
    tabSwitch (ev, n) {
      $(ev.target).parents('.nav-box').find('.right-tab').removeClass('curr');
      $(ev.target).parents('.right-tab').addClass('curr');
      //触发父级点击事件
      this.fatherMethod(n,this.index+1);
      if (n.flowType == 'flow') {
        if (this.tabNav.length) {
          //如果下级有长度，就置空，并且减去长度
          this.updateWidth(-this.twids);
          this.tabNav = [];
        } else {
          this.getFlowOrBlockByFlowId(n, ev);
        }
      }
    },
    getFlowOrBlockByFlowId (item, ev) {
      this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getFlowFloorDataSpit.json", {
          appId: this.$appId,
          flowId:item.id,
          floorEnName:'shelves-display'
        }).then(res => {
          this.tabNav = res.data[0].dataArr;
          //计算新增宽度并传给父级
          var twid = 0;
          res.data[0].dataArr.filter((ite) => ite.name && item.flowType == 'flow').forEach(element => {
            if (element.name) {
              twid += ((element.name.length * 14.5) + 40)
            }
          });
          this.twids = twid;
          this.updateWidth(this.twids);
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.tab{
  // white-space: nowrap;
  // display:inline-block;
  font-size:0;
}
.right-tab {
  position: relative;
  cursor: pointer;
  display: inline-block;
  height: 50px;
  line-height: 51px;
  margin: 0 10px;
  font-size: 14px;
}
.right-tab.curr {
  position: relative;
  border-bottom: 1px solid #0d78cf;
  color: #0d78cf;
}
</style>



// WEBPACK FOOTER //
// src/components/leftRightMenu.vue